"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gold = exports.navy = exports.teal = exports.grey = exports.brick = exports.slate = exports.carbon = exports.success = exports.text = exports.stainlessSteel = exports.glass = exports.primary = exports.black = exports.white = void 0;
// Product colours
var white = '#ffffff';
exports.white = white;
var black = '#000000';
exports.black = black;
var primary = '#1270B8';
exports.primary = primary;
var glass = '#fafafa';
exports.glass = glass;
var stainlessSteel = 'hsv(0, 0, 94%)';
exports.stainlessSteel = stainlessSteel;
var text = '#262626';
exports.text = text;
var success = '#72c040';
exports.success = success;
var carbon = '#262626';
exports.carbon = carbon;
var slate = '#595959'; // Brand colours

exports.slate = slate;
var brick = {
  100: '#f7e9e8',
  200: '#efd3d2',
  300: '#d7918e',
  400: '#c76560',
  500: '#b73933',
  600: '#AF231C',
  700: '#8c1c16',
  800: '#7a1914'
};
exports.brick = brick;
var grey = {
  98: '#fafafa',
  99: '#f5f5f5',
  100: '#EDEDED',
  200: '#DBDBDB',
  300: '#A5A6A4',
  400: '#808280',
  500: '#5C5E5B',
  600: '#4a4c49',
  700: '#2C2E2C',
  800: '#1E1E1D'
};
exports.grey = grey;
var teal = {
  100: '#E6F3F2',
  200: '#B3DAD7',
  300: '#80C2BC',
  400: '#4DAAA1',
  500: '#1A9186',
  600: '#008578',
  700: '#04786C',
  800: '#035D54'
};
exports.teal = teal;
var navy = {
  100: '#E9EAEC',
  200: '#BCBFC7',
  300: '#8F95A2',
  400: '#626A7C',
  500: '#353F57',
  600: '#1F2A44',
  700: '#192236',
  800: '#131929'
};
exports.navy = navy;
var gold = {
  100: '#FCF6E6',
  200: '#F5E4B3',
  300: '#EFD280',
  400: '#E6C24E',
  500: '#E2AE1A',
  600: '#DFA500',
  700: '#B28400',
  800: '#9C7300'
};
exports.gold = gold;